import React, {useState} from 'react';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Avatar,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Checkbox,
  MenuItem,
  Button,
  Box
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Iconify from 'src/minimal-components/iconify';
import {ConfirmDialog} from '@components/custom-dialog';

// Define a type for the discussion item properties
interface discussionData {
  id: string;
  title: string;
  description: string;
  date: string;
  members: string[];
}

type DiscussionItemProps = {
  discussion: discussionData;
  author: string;
  onDelete: VoidFunction;
};

// Individual discussion item component
const DiscussionItem: React.FC<DiscussionItemProps> = ({
  discussion,
  author,
  onDelete
}) => {
  const [open, setOpen] = useState(false);
  const [favorited, setIsFavorited] = useState(false);
  const [deleteitem, setDeleteitem] = useState(false);
  // Open the dialog
  const handleClickOpen = () => {
    setOpen(true);
  };

  // Close the dialog
  const handleClose = () => {
    setOpen(false);
  };
  const handledialogclose = () => {
    setDeleteitem(false);
  };
  const handlefavouritechanges = () => {
    setIsFavorited(!favorited);
  };
  const handlechange = () => {
    setDeleteitem(false);
  };

  return (
    <React.Fragment>
      <Card
        variant="outlined"
        sx={{
          marginBottom: 2,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'baseline',
          boxShadow: '0 2px 8px 0 rgb(11 124 237 / 96%)',
          justifyContent: 'space-between'
        }}>
        <CardContent onClick={handleClickOpen} sx={{display: 'flex'}}>
          <Avatar>{author[0]}</Avatar>
          <div>
            <Typography variant="h5" component="div">
              {discussion.title}
            </Typography>
            <Typography sx={{mb: 1.5}} color="text.secondary">
              {author}
            </Typography>
          </div>
        </CardContent>
        <CardActions disableSpacing>
          <div style={{display: 'flex', justifyContent: 'end'}}>
            <Checkbox
              color="warning"
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1em"
                  height="1em"
                  viewBox="0 0 32 32">
                  <g fill="none">
                    <path
                      fill="#0d0d0d"
                      d="M6 6c4.665-2.332 8.5.5 10 2.5c1.5-2 5.335-4.832 10-2.5c6 3 4.5 10.5 0 15c-2.196 2.196-6.063 6.063-8.891 8.214a1.764 1.764 0 0 1-2.186-.041C12.33 27.08 8.165 23.165 6 21C1.5 16.5 0 9 6 6"
                    />
                    <path
                      fill="black"
                      d="M16 8.5v3.05c1.27-2.685 4.425-6.27 9.658-5.713c-4.51-2.03-8.195.712-9.658 2.663m-4.054-2.963C10.26 4.95 8.225 4.887 6 6C0 9 1.5 16.5 6 21c2.165 2.165 6.33 6.08 8.923 8.173a1.764 1.764 0 0 0 2.186.04c.254-.193.516-.4.785-.618c-2.854-2.143-6.86-5.519-9.035-7.462c-4.957-4.431-6.61-11.815 0-14.769a9.706 9.706 0 0 1 3.087-.827"
                    />
                    <ellipse
                      cx="23.477"
                      cy="12.594"
                      fill="black"
                      rx="2.836"
                      ry="4.781"
                      transform="rotate(30 23.477 12.594)"
                    />
                  </g>
                </svg>
              }
              checkedIcon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1em"
                  height="1em"
                  viewBox="0 0 32 32">
                  <g fill="none">
                    <path
                      fill="#f8312f"
                      d="M6 6c4.665-2.332 8.5.5 10 2.5c1.5-2 5.335-4.832 10-2.5c6 3 4.5 10.5 0 15c-2.196 2.196-6.063 6.063-8.891 8.214a1.764 1.764 0 0 1-2.186-.041C12.33 27.08 8.165 23.165 6 21C1.5 16.5 0 9 6 6"
                    />
                    <path
                      fill="#ca0b4a"
                      d="M16 8.5v3.05c1.27-2.685 4.425-6.27 9.658-5.713c-4.51-2.03-8.195.712-9.658 2.663m-4.054-2.963C10.26 4.95 8.225 4.887 6 6C0 9 1.5 16.5 6 21c2.165 2.165 6.33 6.08 8.923 8.173a1.764 1.764 0 0 0 2.186.04c.254-.193.516-.4.785-.618c-2.854-2.143-6.86-5.519-9.035-7.462c-4.957-4.431-6.61-11.815 0-14.769a9.706 9.706 0 0 1 3.087-.827"
                    />
                    <ellipse
                      cx="23.477"
                      cy="12.594"
                      fill="#f37366"
                      rx="2.836"
                      ry="4.781"
                      transform="rotate(30 23.477 12.594)"
                    />
                  </g>
                </svg>
              }
              checked={favorited}
              onChange={handlefavouritechanges}
            />
            <MenuItem
              onClick={() => {
                setDeleteitem(true);
              }}
              sx={{color: 'error.main'}}>
              <Iconify icon="solar:trash-bin-trash-bold" />
            </MenuItem>
            <IconButton aria-label="settings">
              <MoreVertIcon />
            </IconButton>
          </div>
          <Typography variant="body2" style={{marginLeft: 'auto'}}>
            {discussion.date}
          </Typography>
        </CardActions>
      </Card>

      {/* Dialog component */}
      <Dialog open={open} onClose={handleClose} sx={{p: 1}}>
        <DialogTitle>{discussion.title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div>
              <p>
                Details about &quot;{discussion.description}&quot; can be shown
                here.
              </p>
              <div>
                {discussion.members.map((member, index) => (
                  <h4 key={index}>{member}</h4>
                ))}
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <ConfirmDialog
        open={deleteitem}
        onClose={() => handlechange()}
        title="Delete"
        content="Are you sure want to delete?"
        action={
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              onDelete();
              handledialogclose(); // This will close the dialog
            }}>
            Delete
          </Button>
        }
      />
    </React.Fragment>
  );
};

// Main component that maps through an array of discussions
const DiscussionList: React.FC<{
  discussion: discussionData[];
  setDiscussion: any;
}> = ({discussion, setDiscussion}) => {
  console.log('discussion', discussion);
  const author = 'Pulla Reddy';
  const handledelete = (index: string) => {
    console.log('index', index);
    console.log('discussion', discussion);
    setDiscussion(discussion.filter(discussion => discussion.id !== index));
    console.log('discussion', discussion);
  };

  return (
    <Box sx={{paddingY: '2vh'}}>
      {discussion.map(discussion => (
        <DiscussionItem
          key={discussion.id}
          discussion={discussion}
          author={author}
          onDelete={() => handledelete(discussion.id)}
        />
      ))}
    </Box>
  );
};

export default DiscussionList;
